import pattern from 'patterns/attachments';
import { WCCContentTextBlock } from '../blocks/text/text';
import WCCContentPatternRule from './pattern';

export default class WCCContentAttachmentsDummyRule extends WCCContentPatternRule {
    protected pattern = pattern;

    protected process() {
        return new WCCContentTextBlock(' ... ');
    }
}